import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';  // Import loading spinner
import { useTranslation } from 'react-i18next';
import { Approval, CancelOutlined } from '@mui/icons-material';

const DialogConfirm = ({ open, title, content, onClose, onConfirm, loading,confirmButton }) => {
    const { t } = useTranslation();
    const [isDisabled, setIsDisabled] = useState(false);
    const [confirmInfo, setConfirmInfo] = useState('button.confirm');

    // Use useEffect to track changes in loading and update the button disabled state
    useEffect(() => {
        if (confirmButton) {
            setConfirmInfo(confirmButton);
        }
        setIsDisabled(loading);  // Disable the buttons if loading is true
    }, [loading,confirmButton]);

    return (
        <Dialog
            fullWidth
            maxWidth="sm"
            scroll="paper"
            open={open} 
            onClose={!loading ? onClose : null}  // Prevent closing the dialog while loading
            disableEscapeKeyDown={loading}  // Disable escape key when loading
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <div style={{ padding: '6px 0' }}>
                    {content}
                </div>
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={onClose} 
                    color="error" 
                    startIcon={<CancelOutlined />}
                    disabled={isDisabled}  // Disable the "Cancel" button when loading
                >
                    {t('button.cancel')}
                </Button>
                <Button 
                    onClick={onConfirm} 
                    color="primary" 
                    startIcon={loading ? <CircularProgress size={24} /> : <Approval />}  // Show spinner when loading
                    disabled={isDisabled}  // Disable the "Confirm" button when loading
                    autoFocus
                >
                    {loading ? t('message.loading') : t(confirmInfo)}  {/* Change button text when loading */}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DialogConfirm;
